module.exports = __webpack_public_path__ + "img/inbox_p.a3ef3ed1.svg";